import React from "react";
import { Link } from "react-router-dom";
import EntityApi from "../Api/EntityApi";
import CopyIcon from "../components/CopyIcon";


function RegistrationConfirm({state, service, jsonServer}) {

    const app = state.response;
    const inviteUrl = '/minsida?lRef='+app.longReference;
    const entityApi = new EntityApi(jsonServer);
    return (
        <>
                <h1>Tack för din anmälan!</h1>
                <h4>Glöm inte att betala. Anmälan är giltig först när betalning skett.</h4>

                <h3>Anmälda</h3>
                {
                        app.runners.map((a, i) => {
                                const selectedClass = state.classes.filter(c => c.id === a.competitionClass)[0];
                                return (
                                    <p key={a.id}>
                                            {a.firstName} {a.lastName}, {a.club}, {selectedClass.name} {a.bus ? ', buss' : ''}
                                    </p>
                                )
                        })
                }

                Att betala: <span className="totalFee">{app.fee} kr</span>
                <br/>
                Din referens: {app.reference}
                <br/>

                <h3>Uppgifter för 'Min sida'</h3>
                {!app.longReference ? '' : (<>
                        Inloggningskod: <span title={app.longReference}>*****</span>&nbsp;
                        <CopyIcon text={app.longReference} title="Kopiera kod"/>
                        (behövs för inloggning till 'Min sida' om du återvänder och
                        inte direktlänken används.)<br/>
                        Länk för direktinloggning till <Link
                    to={inviteUrl}>Min sida</Link>&nbsp;
                        <CopyIcon text={inviteUrl} title="Kopiera länk"/>
                </>)}
                <h3>Betalning</h3>

                Betalning skall ske via swish till nummer <b>{state.competition.swishNo}</b>&nbsp;
                <CopyIcon text={state.competition.swishNo} title="Kopiera nummer"/>
                &nbsp;
                ({state.competition.paymentReceiver})
                eller bankgiro: <b>{state.competition.bgNo}</b>.<br/>

                Ange <b>Kanallöpet {app.reference}</b>&nbsp;
                <CopyIcon text={'Kanallöpet ' + app.reference} title="Kopiera text"/>
                &nbsp;
                på betalningen. Anmälan är giltig först när betalning skett.<br/>
                Manuell kontroll av betalning görs dagligen och först därefter uppdateras betalstatus
                på anmälningssammanställningen och på 'Min sida'. När betalningen är registrerad
                kan du skriva ut ett kvitto från 'Min sida'.
                <br/>
                <br/>
                Sitter du vid en dator kan du skanna QR-koden nedan med Swish-appen i din telefon för att få Swish-betalningen
                förifylld. Har du anmält dig med din telefon, kan du kopiera telefonnummer och meddelandet genom
                att klicka på kopieringssymbolen och klistra in i respektive fält i Swish-appen, fylla i beloppet
                och Swisha på vanligt sätt.
                <br/>
                <br/>

                Att betala: <span className="totalFee">{app.fee} kr</span>
                <br/>
                <img src={jsonServer.baseUrl + '/admin/qr.php?db=' + entityApi.db + '&ref=' + app.reference}
                     width="300" height="300" alt="Swish QR-kod"/>

                <br/>
                <i>Om du skannar QR-koden, får du alla betaluppgifter förifyllda.</i>
                <br/>
        </>
    );
}

export default RegistrationConfirm;